'use client';
import React, { useEffect, useRef, useState } from 'react';

export default function MintCounter() {
  const [count, setCount] = useState(47382);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCount((c) => c + Math.floor(Math.random() * 3));
    }, 3000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <div
      className="inline-flex items-center gap-3 px-4 py-2.5 rounded-full font-body"
      style={{
        background: 'rgba(61,255,196,0.10)',
        border: '1px solid rgba(61,255,196,0.3)',
      }}
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="mint-pulse absolute inline-flex h-full w-full rounded-full bg-mint opacity-75" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-mint" />
      </span>
      <span className="text-sm font-display font-700 text-mint tabular-nums">
        {count.toLocaleString()}
      </span>
      <span className="text-sm text-white/50">luck incidents logged today</span>
    </div>
  );
}